module.exports = __webpack_public_path__ + "static/img/osacian.c9ab834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/osacian.png
// module id = 246
// module chunks = 1